import React, { useState } from 'react';
import './styles.scss';
import { HeaderCommon } from 'components/Atoms';
import cn from 'classnames';
import { Col, Empty, Row } from 'antd';
import { ModalListCampaign } from '..';
import { FormattedMessage, useIntl } from "react-intl";

const ListCampaign = ({
  showHeader = true,
  campaigns = [],
  className,
  showLimit = 5,
  isModal = false,
}) => {
  const [visible, setVisible] = useState(false);
  const intl = useIntl();

  return (
    <div className={cn('list-campaign-wrapper h-100p', className)}>
      {showHeader && (
        <HeaderCommon className="p-20" title={intl.formatMessage({ id: 'list_campaign.title' })}>
          {campaigns.length > showLimit && (
            <div
              className="f-right t-right fw-600 fz-16 text-dark-gray action"
              onClick={() => setVisible(true)}
            >
              <span><FormattedMessage id="list_campaign.see_all" /></span>
            </div>
          )}
        </HeaderCommon>
      )}
      <div className={cn('px-20 py-30', { 'scroll-y h-690': isModal })}>
        {!campaigns?.length && <Empty description={<FormattedMessage id='list_campaign.no_campaign' />} />}
        {campaigns.map(
          (el, idx) =>
            idx < showLimit && (
              <Row
                key={el.id}
                className={cn('list-campaign-item', { 'mt-30': idx > 0 })}
                gutter={[17]}
                wrap={false}
              >
                <Col className="name text-1-line">
                  <span>
                    <span className="text-dark-gray">{++idx}.</span> {el.name}
                  </span>
                </Col>
                <Col
                  flex="auto"
                  className={cn('status t-right', el.status?.toLowerCase())}
                >
                  {el.status}
                </Col>
              </Row>
            )
        )}
      </div>
      <ModalListCampaign
        visible={visible}
        onClose={() => setVisible(false)}
        campaigns={campaigns}
      />
    </div>
  );
};

export default ListCampaign;
